import { InsightsLensData } from '@upright/ui/common/upright/core/impact-lenses/insights/types';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { useCarouselContext } from '../../../impact-lens-profile/context';

export function useInsightsLensContext() {
  const context = useCarouselContext<ImpactLensType.INSIGHTS>();
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context.lensType === ImpactLensType.INSIGHTS) {
    return { data: context.data as InsightsLensData, selection: context.selectionState };
  }
  return undefined;
}
